import styled, { keyframes } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { ANIMATION_FUNCTION } from "@similarweb/ui-components";

const PUMP_COUNT = 2;
const PUMP_DURATION = "2s";

const FOLD_TRANSITION = `200ms ${ANIMATION_FUNCTION}`;
const FOLD_COLLAPSE_DELAY = "300ms";

const DOT_SIZE_EXPANDED = "10px";
const DOT_SIZE_COLLAPSED = "6px";
const DOT_RIGHT_EXPANDED = "16px";
const DOT_RIGHT_COLLAPSED = "3px";
const DOT_TOP_COLLAPSED = "30%";
const DOT_TOP_EXPANDED = "50%";

const pump = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.35); }
`;

const halo = keyframes`
    0% { transform: scale(1); opacity: 0.5; }
    100% { transform: scale(2.6); opacity: 0; }
`;

export const IndicatorWrapper = styled.div<{ $isCollapsed: boolean }>`
    position: absolute;
    top: ${({ $isCollapsed }) => ($isCollapsed ? DOT_TOP_COLLAPSED : DOT_TOP_EXPANDED)};
    right: ${({ $isCollapsed }) => ($isCollapsed ? DOT_RIGHT_COLLAPSED : DOT_RIGHT_EXPANDED)};
    width: ${({ $isCollapsed }) => ($isCollapsed ? DOT_SIZE_COLLAPSED : DOT_SIZE_EXPANDED)};
    height: ${({ $isCollapsed }) => ($isCollapsed ? DOT_SIZE_COLLAPSED : DOT_SIZE_EXPANDED)};
    transform: translateY(-50%);
    pointer-events: none;
    transition:
        width ${FOLD_TRANSITION},
        height ${FOLD_TRANSITION},
        right ${FOLD_TRANSITION};
    transition-delay: ${({ $isCollapsed }) => ($isCollapsed ? FOLD_COLLAPSE_DELAY : "0ms")};
`;

export const Dot = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[400]};
    animation: ${pump} ${PUMP_DURATION} ease-in-out ${PUMP_COUNT};
`;

export const Halo = styled.div`
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[400]};
    animation: ${halo} ${PUMP_DURATION} ease-out ${PUMP_COUNT};
`;

export const Container = styled.div`
    position: relative;
    cursor: pointer;
`;
